import { ReactNode } from 'react';

import { Avatar, AvatarFallback, AvatarImage } from 'components/v2/ui/avatar.tsx';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from 'components/v2/ui/dialog.tsx';

interface PersonAvatarTypes {
  link: string;
  fallback: string;
  subtitle?: string | null;
  size?: string;
  isModal?: boolean;
  children: ReactNode;
}

const PersonAvatar = ({ link, fallback, subtitle, size = 'size-12', isModal = false, children }: PersonAvatarTypes) => {
  const avatarImg = (
    <AvatarImage
      className={'rounded-full'}
      src={link}
    />
  );

  return (
    <div className="mb-2">
      <div className="flex justify-items-start md:flex-col md:justify-items-center">
        <Avatar className={size}>
          {isModal ? (
            <Dialog>
              <DialogTrigger className="cursor-pointer">{avatarImg}</DialogTrigger>
              <DialogTitle />
              <DialogContent className="top-[30%] flex h-[90vh] max-w-sm translate-y-[-25vh] justify-center sm:top-[50%] sm:max-w-2/3 sm:translate-y-[-50%] lg:max-w-3/5 xl:max-w-1/2">
                <img
                  className={'rounded-lg object-contain'}
                  src={link}
                  alt=""
                />
              </DialogContent>
            </Dialog>
          ) : (
            avatarImg
          )}
          <AvatarFallback>{fallback}</AvatarFallback>
          {children}
        </Avatar>
        {subtitle && (
          <span className="mt-3 ml-4 text-center text-xs tracking-wide text-gray-500 sm:text-sm md:ml-0">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

export default PersonAvatar;
